import React from 'react'
import './articles.css'
const Nipt = () => {
  return (
    <div class="articlecontainer">
    <header>
      <h1>How to Obtain a Unique Business Identification Number (NIPT) in Albania</h1>
      <p>Once your business is registered with the <strong>National Business Center (QKB)</strong>, the next step is obtaining a <strong>Unique Business Identification Number (NIPT)</strong>. This number is essential for tax purposes and legally operating in Albania.</p>
    </header>

    <section class="step">
      <h2>Step 1: Check Your Business Registration Status</h2>
      <p>Your company registration typically takes <strong>1-2 working days</strong>. After <strong>24 hours</strong>, you can check your registration status on the QKB website:</p>
      <ul>
        <li>Go to the <strong>QKB website</strong> → Search for your company name.</li>
        <li>If registered, you can download:
          <ul>
            <li><strong>Registration Certificate</strong> (includes your NIPT).</li>
            <li><strong>Registration Extract</strong> (business details).</li>
          </ul>
        </li>
      </ul>
    </section>

    <section class="step">
      <h2>Step 2: Display Your NIPT Certificate</h2>
      <p>Your <strong>Registration Certificate</strong> is an important legal document. It contains your <strong>NIPT number</strong> (formatted as <code>X12345678Y</code>) and serves as proof of registration.</p>
      <p><strong>Requirement:</strong> The certificate must be displayed in a visible spot in your office.</p>
    </section>

    <section class="step">
      <h2>Step 3: Register Your Business on e-Albania</h2>
      <p><strong>e-Albania</strong> is the government’s online portal for accessing various public services. Both Albanian citizens and businesses must register here to manage tax filings, invoices, and other administrative tasks.</p>
      <ul>
        <li>Go to <strong>e-Albania</strong> and select <strong>"Register Your Business as a Foreign Citizen"</strong>.</li>
        <li>Enter your business details, including your NIPT number.</li>
        <li>Once registered, you can access government services, tax reporting, and official documents online.</li>
      </ul>
    </section>

    <footer>
      <p><strong>Final Thoughts:</strong> Your <strong>NIPT number</strong> is your company’s tax ID and must be used in all financial and legal transactions. Completing your <strong>e-Albania</strong> registration ensures you can efficiently manage your business in Albania.</p>
    </footer>
  </div>
  )
}

export default Nipt